var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:#1E1E1C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 441.1,
    cy: 441.1,
    r: 440.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M850.1,277.5c-11.7-29.3-26.5-57-44.1-83.1C726.8,77.3,592.7,0.5,440.9,0.5C197.5,0.5,0.5,197.9,0.5,440.9 c0,243.4,197.4,440.8,440.4,440.8c152.1,0,285.9-76.8,365.1-193.9c17.6-25.7,32-53.4,44.1-82.7c20.3-50.7,31.6-106.1,31.6-163.8 C881.3,383.6,870.4,328.2,850.1,277.5z M791.2,396.4H286.8c7.8-27.3,22.2-51.5,41.7-70.6c29.6-29.6,70.6-48,115.9-48h309.7 C773.3,314.1,785.8,353.9,791.2,396.4z M438.6,85.9c100.3,0,191.1,41.7,255.9,108.8H455.3c-68.3,0-129.9,27.7-174.4,72.2 c-34.7,34.7-58.9,79.2-67.9,129.5H86.3C108.2,221.3,257.6,85.9,438.6,85.9z M438.6,797.1c-181,0-330.4-135.4-352.6-310.5h126.8 c21.1,114.7,121.7,201.7,242.6,201.7h239.1C630.1,755.3,539.2,797.1,438.6,797.1z M444.4,605.5c-74.9,0-138.1-50.3-157.6-119h504.4 c-5.5,42.5-18.3,82.3-37.1,119H444.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWldIcon);
export default __webpack_public_path__ + "static/media/wld_icon.38f32222ed505d6a216362885ef1ac8a.svg";
export { ForwardRef as ReactComponent };